import React, { useEffect, useState } from 'react';
import { listMySorties } from '../../api/sorties';
import { listMyIssues } from '../../api/issues';
import { getCurrentSemestre } from '../../api/semestres';

export default function StudentDashboard() {
  const [stats, setStats] = useState({ sorties: 0, pending: 0, accepted: 0, issuesActive: 0 });
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [sorties, issues, cur] = await Promise.all([listMySorties(), listMyIssues(), getCurrentSemestre()]);
        setCurrent(cur);
        const pending = (sorties || []).filter(s => s.statut === 'PENDING').length;
        const accepted = (sorties || []).filter(s => s.statut === 'ACCEPTED').length;
        const issuesActive = (issues || []).filter(i => i.statut === 'OPEN' || i.statut === 'IN_PROGRESS').length;
        setStats({ sorties: sorties.length || 0, pending, accepted, issuesActive });
      } catch { /* ignore */ }
    })();
  }, []);

  const CARDS = [
    { label: 'Mes sorties',        value: stats.sorties,      color: '#3b82f6', bg: '#e6f1fb' },
    { label: 'En attente',         value: stats.pending,      color: '#faad14', bg: '#faeeda' },
    { label: 'Approuvées',         value: stats.accepted,     color: '#3b6d11', bg: '#eaf3de' },
    { label: 'Signalements actifs',value: stats.issuesActive, color: '#e24b4a', bg: '#fcebeb' },
  ];

  return (
    <div className="page">
      <div className="section-label">Mon tableau de bord</div>
      {current && (
        <p style={{ fontSize: 12, color: '#888', marginBottom: 14 }}>
          Semestre actif : <strong>{current.nom} {current.annee}</strong>
        </p>
      )}
      <div className="stats-grid">
        {CARDS.map((c) => (
          <div className="stat-card" key={c.label}>
            <div className="stat-label">{c.label}</div>
            <div className="stat-value" style={{ color: c.color }}>{c.value}</div>
            <div className="stat-bar" style={{ background: c.bg }}>
              <div className="stat-bar-fill" style={{ background: c.color, width: `${Math.min(100, (c.value / 20) * 100)}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
